module.exports = __webpack_public_path__ + "img/green-carpet-grass-05.a11e79e6.png";